export const _toaster = {
  pinCodeError: 'This Pincode is unserviceable',
  pinCodeSuccess: 'Delivery is available to this Pincode',
  OutOfstockProduct: 'Please remove out of stock product',
  wishlistAuth: 'Please login for wishlisting a product',
  codCheck: 'COD is not available for this pincode',
  warrantyMandatory: 'Please Select Warranty.',
  paymentError: 'Please select Payement Method',
  addressError: 'Please select Address'
}
